import React, { Dispatch, useEffect } from 'react'
import Button from '../../../components/button/Button'
import { compose } from 'recompose'
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles'
import styles from '../../../theme/styles'
import { makeStyles } from '@material-ui/core/styles'
import fetchFactory from '../../../utils/fetchFactory'
import errorCatcher from '../../../utils/errorCatcher'
import { connect } from 'react-redux'
import CircularProgress from '@material-ui/core/CircularProgress'

const useStyles = makeStyles(theme => ({
	buttonContainer: {
		height: 48,
		paddingBottom: 20
	},
	button: {
		width: '100%',
		display: 'contents',
		justifyContent: 'space-between',
		alignItems: 'center',

		'& img': {
			marginRight: 10
		}
	},
	spinnerStyle: {
		textAlign: 'center',

		'& div': {
			width: '100px !important',
			height: '100px !important'
		}
	}
}))

interface ModelBouton {
	id: number,
	texte: string,
}

interface Store {
	errorCatcher: (error: any, id: string) => void
}

const texteTelecharger: string = 'Télécharger'

type ListeBoutonsGrandProps = WithStyles<typeof styles> & Store

const ListeBoutonsGrand = (
	props: ListeBoutonsGrandProps
) => {
	const {
		classes,
		errorCatcher
	} = props

	const customClasses = useStyles()

	const [boutons, setBoutons] = React.useState<ModelBouton[]>([])
	const [loading, setLoading] = React.useState<boolean>(false)

	useEffect(() => {
		setBoutons([
			{
				id: 4,
				texte: texteTelecharger
			}
		])
	}, [])

	const onButtonClicked = () => {
		setLoading(true)

		fetchFactory('/api/telecharger/detail/avoirs', {
			method: 'POST'
		}, 'blob')
			.then(
				(blob: any) => {
					const url = window.URL.createObjectURL(blob)
					const a = document.createElement('a')
					a.href = url
					a.download = 'detail_avoirs.csv'
					a.click()
				}
			)
			.catch(
				(error: any) => {
					errorCatcher(error, 'detail_avoirs')
				}
			)
			.finally(
				() => {
					setLoading(false)
				}
			)
	}

	return (
		<>
			{
				!loading && boutons.map(bouton => (
					<div
						className={customClasses.buttonContainer}
						key={bouton.id}
					>
						<Button
							disabled={false}
							onClick={onButtonClicked}
						>
							<span className={customClasses.button}>
								<img
									src= "/img/pictos_pdf.svg"
									alt= "pdf icon"
									width= "20"
									height= "20"
									className={classes.colorSecondary}
								/>
								<span className={classes.textSize}>{bouton.texte}</span>
							</span>
						</Button>
					</div>
				))
			}

			{
				loading &&
				<div className={customClasses.spinnerStyle}>
					<CircularProgress color="primary" />
				</div>
			}
		</>
	)
}

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
	return {
		errorCatcher: (error: any, id: string) => {
			dispatch(errorCatcher(error, id))
		}
	}
}

const EnhancedListeBoutonsGrand = compose<ListeBoutonsGrandProps, {}>(
	connect(null, mapDispatchToProps),
	withStyles(styles)
)(ListeBoutonsGrand)

export default EnhancedListeBoutonsGrand
